// export const APP_UPDATE_DATE_RANGE = "APP_UPDATE_DATE_RANGE";
export const APP_UPDATE_PAGE_TITLE = 'APP_UPDATE_PAGE_TITLE';
export const APP_UPDATE_DATE_RANGE = 'APP_UPDATE_DATE_RANGE';
export const APP_UPDATE_SETTINGS = 'APP_UPDATE_SETTINGS';
export const APP_UPDATE_SETTING = 'APP_UPDATE_SETTING';
export const APP_ADD_LIST_SETTING_ITEM = 'APP_ADD_LIST_SETTING_ITEM';
export const APP_REMOVE_LIST_SETTING_ITEM = 'APP_REMOVE_LIST_SETTING_ITEM';
export const APP_UPDATE_STRIPE_KEY = 'APP_UPDATE_STRIPE_KEY';
export const APP_UPDATE_INITIALIZED = 'APP_UPDATE_INITIALIZED';
export const APP_UPDATE_ADMIN_INITIALIZED = 'APP_UPDATE_ADMIN_INITIALIZED';
export const APP_UPDATE_PICKER_STATUS = 'APP_UPDATE_PICKER_STATUS';
export const APP_UPDATE_SUBSCRIPTION = 'APP_UPDATE_SUBSCRIPTION';
export const APP_ADD_TRANSLATION = 'APP_ADD_TRANSLATION';

export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_UPDATE_ROLES = 'USER_UPDATE_ROLES';
export const USER_UPDATE_USER = 'USER_UPDATE_USER';
export const USER_UPDATE_JWT = 'USER_UPDATE_JWT';
export const USER_UPDATE_REGISTER_INFO = 'USER_UPDATE_REGISTER_INFO';

export const SERVICE_UPDATE_SERVICES = 'SERVICE_UPDATE_SERVICES';
export const SERVICE_ADD_VERSION = 'SERVICE_ADD_VERSION';
export const SERVICE_UPDATE_INITIALIZED = 'SERVICE_UPDATE_INITIALIZED';

export const DEPLOYMENT_UPDATE_SELECTED_DEPLOYMENT =
  'DEPLOYMENT_UPDATE_SELECTED_DEPLOYMENT ';

export const TRANSLATIONS_UPDATE_TRANSLATIONS =
  'TRANSLATIONS_UPDATE_TRANSLATIONS';
export const TRANSLATIONS_UPDATE_LOCALES = 'TRANSLATIONS_UPDATE_LOCALES';
export const TRANSLATIONS_ADD_TRANSLATIONS = 'TRANSLATIONS_ADD_TRANSLATION';
export const TRANSLATIONS_UPDATE_FILTER_NAMESPACE =
  'TRANSLATIONS_UPDATE_FILTER_NAMESPACE';
export const TRANSLATIONS_UPDATE_FILTER_GROUP =
  'TRANSLATIONS_UPDATE_FILTER_GROUP';
export const TRANSLATIONS_UPDATE_FILTER_KEY = 'TRANSLATIONS_UPDATE_FILTER_KEY';
export const TRANSLATIONS_UPDATE_FILTER_VALUE =
  'TRANSLATIONS_UPDATE_FILTER_VALUE';
export const TRANSLATIONS_UPDATE_FILTER_LOCALE =
  'TRANSLATIONS_UPDATE_FILTER_LOCALE';
